import $ from "/srv/www/v/voicetovoice.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function() {
    //
    $('.start-chat').on('click', function(event) {
        event.preventDefault();
        $('._steamlive_chat_frame').contents().find('span')[0].click();
      });
});
